/** Who the loan is for. Same values as the old BClientOrEntitySelectorType. */
export enum BorrowerType {
    /** "Borrower with B-Client": a broker agreement, which brings its own borrower and broker. */
    BClient = 0,
    /** "Borrower Only": a borrower entity. */
    Entity = 1,
}

/** What BorrowerSelector hands back on every change. */
export interface BorrowerSelection {
    borrowerType: BorrowerType;
    borrowerEntityId: number | undefined;
    brokerAgreementId: number | undefined;
}
